export function isNegative(value: number) {
  return Math.sign(value) < 0;
}
